import moment from "moment";
import "moment/locale/vi";

// set moment globally
moment.locale("vi");

export const fromNow = (value?: string) => {
  if (!value) return "";
  const utcTime = moment.utc(value, "YYYY-MM-DD HH:mm:ss");
  const localTime = utcTime.local();
  return moment(localTime, "YYYY-MM-DD HH:mm:ss").fromNow();
};

export const formatDate = (
  date?: string,
  format: string = "YYYY-MM-DD HH:mm:ss"
) => {
  if (!date) return "";
  return moment.utc(date).local().format(format);
};
